import { render, staticRenderFns } from "./ViewDeal.vue?vue&type=template&id=2ce270c6&scoped=true"
import script from "./ViewDeal.vue?vue&type=script&lang=js"
export * from "./ViewDeal.vue?vue&type=script&lang=js"
import style0 from "./ViewDeal.vue?vue&type=style&index=0&id=2ce270c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce270c6",
  null
  
)

export default component.exports